var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / fbs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.87108065,9.48627621 L9.73959004,9.48627621 L10.6068138,10.0199524 L6.7376616,10.0199524 L5.00321406,15.356714 C3.06863796,14.6229093 1.33419042,12.8884618 0.600385687,10.9538857 C-0.200128562,9.08601909 -0.200128562,6.75118586 0.600385687,4.88331928 C1.33419042,3.01545269 3.202057,1.28100515 5.1366331,0.547200424 C6.67095208,-0.0531852637 8.67223771,-0.119894784 10.2732662,0.347071861 C12.1411328,0.880748028 13.8755803,2.21493844 14.8762231,3.94938599 C16.010285,5.81725257 16.3438326,8.28550484 15.6100279,10.4202095 C15.1430612,11.887819 14.2758375,13.2220094 13.0083566,14.2226522 L10.9403614,10.6870476 L13.8755803,12.3547856 C13.8755803,12.3547856 13.8755803,12.3547856 13.8755803,12.2880761 L10.0064281,8.95260005 L15.0096422,9.68640478 L15.0096422,9.68640478 L14.9429327,9.68640478 L10.3399757,8.01866676 L15.2764803,6.81789538 L15.2764803,6.81789538 L10.2732662,7.15144299 L14.2091279,4.14951455 C14.2091279,4.14951455 14.2091279,4.14951455 14.1424184,4.14951455 L9.73959004,6.41763826 L12.2078423,2.0815194 L12.2078423,2.0815194 L9.00578531,5.81725257 L9.606171,0.880748028 C9.606171,0.880748028 9.606171,0.880748028 9.53946148,0.880748028 L8.0051425,5.61712401 L6.7376616,0.680619465 C6.7376616,0.680619465 6.7376616,0.680619465 6.67095208,0.680619465 L7.00449969,5.81725257 L4.06928077,1.88139084 L4.06928077,1.88139084 L6.33740448,6.21750969 L2.00128562,3.88267647 L2.00128562,3.88267647 L5.87043783,7.01802394 L0.867223771,6.5510573 C0.867223771,6.5510573 0.867223771,6.5510573 0.867223771,6.61776682 L5.67030927,8.01866676 L0.933933292,9.35285717 C0.933933292,9.35285717 0.933933292,9.35285717 0.933933292,9.41956669 L5.80372831,8.81918101 L1.9345761,12.0879475 L1.9345761,12.0879475 L2.00128562,12.0879475 L5.06992358,10.486919 L5.80372831,9.35285717 L6.60424256,9.35285717 L6.00385687,8.95260005 L7.93843298,5.88396209 L6.87108065,9.48627621 L6.87108065,9.48627621",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--\\u21B3-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Icons---1em-(16px)",
    transform: "translate(-271.000000, -148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-fbs",
    transform: "translate(271.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#568200",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "$color-brand-06",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbs);
export default __webpack_public_path__ + "static/media/fbs.511884ade2efe43d1b91b16bcf75507e.svg";
export { ForwardRef as ReactComponent };